export default __webpack_public_path__ + "static/media/1891.bc8b168b.png";